var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-icon',{staticClass:"icon_style p-2 mr-2 text-white",attrs:{"icon":_vm.icon,"scale":"4"},on:{"click":function($event){return _vm.$emit('click', {title: _vm.title, text: _vm.text})}}})}
var staticRenderFns = []

export { render, staticRenderFns }